import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import PaymentMethodsPageView from './PaymentMethodsPageView'

/** Nested routes under /payment-methods/* */
const PaymentMethodsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route index element={<PaymentMethodsPageView />} />
        <Route path='*' element={<Navigate to='/payment-methods' replace />} />
      </Route>
    </Routes>
  )
}

export default PaymentMethodsPage
